import { render, staticRenderFns } from "./gdprCookies.vue?vue&type=template&id=56137b38&scoped=true&"
import script from "./gdprCookies.vue?vue&type=script&lang=js&"
export * from "./gdprCookies.vue?vue&type=script&lang=js&"
import style0 from "./gdprCookies.vue?vue&type=style&index=0&id=56137b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56137b38",
  null
  
)

export default component.exports